/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Content from 'components/content/content_container';
import Screen from 'components/screens/screen_container';
import { log } from 'utils/logger';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/layouts/layout_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, { link:true });


/* ========== ~~~~~~~~~~ LAYOUT : CHILD ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached

const Layout = (props) => (
	<div className={`layout ${sheet.classes.layout}`}>
		{props.contents.map(contentId => <Content key={contentId} contentId={contentId}/>)}
		<Screen />
	</div>
);

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Layout;
